var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuditLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83337 8C4.83337 7.72387 5.05723 7.5 5.33337 7.5H10.6667C10.9428 7.5 11.1667 7.72387 11.1667 8C11.1667 8.27613 10.9428 8.5 10.6667 8.5H5.33337C5.05723 8.5 4.83337 8.27613 4.83337 8ZM4.83337 10.3333C4.83337 10.0572 5.05723 9.83333 5.33337 9.83333H9.00004C9.27617 9.83333 9.50004 10.0572 9.50004 10.3333C9.50004 10.6095 9.27617 10.8333 9.00004 10.8333H5.33337C5.05723 10.8333 4.83337 10.6095 4.83337 10.3333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16663 3.50065V3.33398H2.16663V12.6673C2.16663 14.048 3.28591 15.1673 4.66663 15.1673H11.3333C12.714 15.1673 13.8333 14.048 13.8333 12.6673V6.00065C13.8333 4.61994 12.714 3.50065 11.3333 3.50065H3.16663ZM3.16663 4.50065V12.6673C3.16663 13.4957 3.8382 14.1673 4.66663 14.1673H11.3333C12.1617 14.1673 12.8333 13.4957 12.8333 12.6673V6.00065C12.8333 5.17222 12.1617 4.50065 11.3333 4.50065H3.16663Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4074 1.05588C11.5118 0.8981 12.5 1.75511 12.5 2.87079V4.50011H3.38067C2.71017 4.50011 2.16663 3.95656 2.16663 3.28606C2.16663 2.68189 2.61088 2.16966 3.20898 2.08422L10.4074 1.05588ZM11.5 2.87079C11.5 2.36366 11.0508 1.97411 10.5488 2.04583L3.3504 3.07417C3.24495 3.08923 3.16663 3.17954 3.16663 3.28606C3.16663 3.40427 3.26246 3.50011 3.38067 3.50011H11.5V2.87079Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLog);
export default __webpack_public_path__ + "static/media/audit-log.2c94d0991ee2ad5f6b53983c6cb2abe1.svg";
export { ForwardRef as ReactComponent };